<template>
    <div class="container">
        <div class="container-header">
            <div class="search">
                <div class="search-form">
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('shopName') }}</span>
                        <el-input size="mini" v-model="search.name" :placeholder="$t('pleaseInputHint')" clearable @change="searchHandle"></el-input>
                    </div>
                    <div class="form-item">
                        <span class="form-item-lable">{{ $t('merchant') }}</span>
                        <el-select v-model="search.merchantId" size="mini" clearable filterable @change="searchHandle">
                            <el-option v-for="item in merchantOptions"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                </div>
                <div class="search-handle">
                    <el-button type="primary" size="mini" @click="searchHandle">{{ $t('search') }}</el-button>
                    <el-button type="primary" size="mini" @click="emptyHandle">{{ $t('empty') }}</el-button>
                    <el-button type="primary" size="mini" @click="addDialog = true" v-permission="['merc:shop-create']">{{ $t('add') }}</el-button>
                </div>
            </div>
        </div>
        <div class="container-main">
            <el-table
                :data="tableData"
                border
                style="width: 100%">
                <el-table-column type="index" align="center" width="60"></el-table-column>
                <el-table-column min-width="260" :label="$t('shopBasicInfo')">
                    <template slot-scope="scope">
                        <div class="info">
                            <el-image :src="scope.row.logo">
                                <div slot="error" class="image-slot">
                                    <img src="../../assets/images/default.png" alt="">
                                </div>
                            </el-image>
                            <div class="desc avatar-desc">
                                <p class="desc-item">{{ scope.row.name }}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="160" :label="$t('merchantName')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.merchant">{{scope.row.merchant.name}}</span>
                    </template>
                </el-table-column>
                <el-table-column prop="createdAt"
                                 width="180"
                                 :label="$t('creationTime')"
                                 show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span>{{ scope.row.createdAt | formatDate }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    class-name="handle"
                    :label="$t('handle')"
                    align="center"
                    width="180">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="mini"
                            @click="editHandle(scope.row.id)" v-permission="['merc:shop-update']">{{ $t('edit') }}
                        </el-button>
                        <el-button
                            class="red"
                            type="text"
                            size="mini"
                            @click="deleteHandle(scope.row.id)" v-permission="['merc:shop-delete']">{{$t('delete')}}</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                background
                :current-page="currentPage"
                layout="sizes, prev, pager, next, total"
                :page-sizes="[10, 15, 20, 50, 100]"
                :page-size="pageSize"
                :total="total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
            </el-pagination>
        </div>
        <!-- 添加 -->
        <Add
            :parent-dialog="addDialog"
            @parent-update="getListData"
            @parent-close="addDialog = false"/>
        <!-- 编辑 -->
        <Edit
            :parent-dialog="editDialog"
            :parent-id="itemId"
            @parent-update="getListData"
            @parent-close="editDialog = false"/>
    </div>
</template>

<script>
import {queryShopList, deleteShop, searchMerchantList} from "@/api/modules/api";
import Add from '@/components/merchant/shop/Add'
import Edit from '@/components/merchant/shop/Edit'
export default {
    name: "Shop",
    // 组件
    components: {
        Add,
        Edit
    },
    props: {},
    data() {
        return {
            search: {
                name: '',
                merchantId: '',
            },
            merchantOptions: [],
            tableData: [],
            currentPage: 1,
            total: 0,
            pageSize: 10,
            addDialog: false,
            itemId: '',
            editDialog: false,
        };
    },
    // 计算属性
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        // 获取商家列表
        getMerchantOptions() {
            const params = {
                name: ''
            }
            searchMerchantList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.merchantOptions = res.data || []
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 获取数据列表
        getListData() {
            const params = {
                name: this.search.name,
                merchantId: this.search.merchantId,
                page: this.currentPage,
                size: this.pageSize
            }
            queryShopList(params).then(res => {
                if (Number(res.code) === 20000) {
                    this.tableData = res.data.list
                    this.total = res.data.total
                    // 检验是否列表为空
                    if (this.tableData.length === 0 && this.currentPage > 1) {
                        this.currentPage--
                        this.getListData()
                    }
                } else {
                    this.$message({
                        showClose: true,
                        message: res.msg,
                        type: 'error'
                    })
                }
            }).catch(err => {
                this.$message.error(err)
            })
        },
        // 搜索
        searchHandle () {
            // 当前页码初始化
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 清空
        emptyHandle () {
            this.search = {
                name: '',
                merchantId: '',
            }
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 切换页码
        handleCurrentChange (page) {
            // 设置页码
            this.currentPage = page
            // 获取列表数据
            this.getListData()
        },
        // 切换显示条数
        handleSizeChange (size) {
            // 设置大小
            this.pageSize = size
            // 初始化页码
            this.currentPage = 1
            // 获取列表数据
            this.getListData()
        },
        // 编辑
        editHandle (id) {
            this.itemId = id
            this.editDialog = true
        },
        // 删除
        deleteHandle (id) {
            this.$confirm(this.$t('deleteItemHint'), this.$t('hint'), {
                confirmButtonText: this.$t('confirm'),
                cancelButtonText: this.$t('cancel'),
                type: 'warning'
            }).then(() => {
                deleteShop(id).then(res => {
                    if (Number(res.code) === 20000) {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'success'
                        })
                        this.getListData()
                    } else {
                        this.$message({
                            showClose: true,
                            message: res.msg,
                            type: 'error'
                        })
                    }
                }).catch(err => {
                    this.$message.error(err)
                })
            }).catch(() => {})
        },
    },
    // 创建完成
    created() {
    },
    // 挂载完成
    mounted() {
        // 获取列表数据
        this.getListData()
        // 获取商家列表
        this.getMerchantOptions()
    },
    // 销毁之前
    beforeDestroy() {
    }
};
</script>

<style lang="scss" scoped>
@import '../../assets/css/base-column.scss';
</style>
